import { skipToken } from "@reduxjs/toolkit/query";
import { useParams, Navigate, useLocation, Outlet } from "react-router-dom";
import { PartnerPageWrapper } from "src/widgets/partnerPageLayout/ui";
import { useGetPartnerQuery } from "src/shared/api/partner";
import { routes } from "src/shared/constants/routes.constants";

export function PartnerPage() {
  const { partner_id } = useParams();
  const {
    data: partner,
    isLoading: isLoadingGetPartner,
    error,
  } = useGetPartnerQuery(partner_id || skipToken);
  const location = useLocation();
  const { pathname } = location;

  if (!partner_id) {
    return <Navigate to={routes.partners} />;
  }
  if (error && "status" in error && error.status === 404) {
    return <Navigate to="/404" replace />;
  }

  return (
    <PartnerPageWrapper
      partnerId={partner_id}
      partnerName={partner?.name || ""}
      isLoading={isLoadingGetPartner}
      tabValue={pathname}
    >
      <Outlet />
    </PartnerPageWrapper>
  );
}
